import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { ALERT } from '../../constants/actionTypes'

import './Alert.css'

const Alert = () => {
    const dispatch = useDispatch()
    const alert = useSelector(state => state.alert)
    const severity = alert.severity === 'error' ? 'crimson' : alert.severity === 'success' ? 'rgb(0, 172, 0)' : alert.severity === 'warning' ? 'rgb(184, 134, 11)'
        : alert.severity === 'info' ? '#039fbe' : 'rgb(0, 172, 0)'

    useEffect(() => {
        if(alert.display) {
            setTimeout(() => {
                dispatch({type: ALERT, payload: {...alert, display: false}})
            }, alert.duration);
        }
    }, [alert, dispatch])

    const style = {
        height: '50px',
        backgroundColor: severity
    }

    return (
        <div style={alert.display ? style : {}} className="alert">
            {alert.message}
        </div>
    )
}

export default Alert
